import React, {FunctionComponent} from "react";
import './WizardStepSummary.scss';
import {MscWizardProps} from "../../interfaces";
import Api from "../../Api";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSpinner} from "@fortawesome/free-solid-svg-icons";

const WizardStepSummary: FunctionComponent<MscWizardProps> = (props) => {

    return <div className="msc-anmeldung__wizard-step-three">
        {props.state.abonierenState === "aboniere" ? <div className="msc-anmeldung__loading">
            <FontAwesomeIcon icon={faSpinner} pulse={true}/>
        </div> : <></>}
        <h1>Zusammenfassung</h1>
        <h2>Wollen Sie diese Benachrichtigung wirklich einrichten?</h2>
        <div className="msc-anmeldung__wizard-step-three__content">
            <div>
                <h3>Adresse</h3>
                <p>{props.state.ausgewaehlteAdresse?.strasse} {props.state.ausgewaehlteAdresse?.hausnummer}</p>
                <p>{props.state.ausgewaehlteAdresse?.postleitzahl} {props.state.ausgewaehlteAdresse?.ort}</p>
            </div>
            <div>
                <h3>Handynummer</h3>
                <p>{props.state.kontakt.nummer}</p>
            </div>
        </div>
        {props.state.abonierenState === 'abonieren_fehlgeschlagen' ? <p className="msc-anmeldung__wizard-step-two__validierungshinweis">
            Das Abonnement konnte nicht eingerichtet werden. Bitte überprüfen Sie Ihre Eingaben und versuchen es erneut.
        </p> : <></>}
        <div>
            <button
                type="button"
                className="msc-anmeldung__btn"
                disabled={props.state.abonierenState === 'aboniere'}
                onClick={() => {
                    props.dispatch({
                        type: 'ABONIERE'
                    });
                    Api.aboniere(props.state.kontakt.nummer, props.state.ausgewaehlteAdresse?.id as number, (new AbortController()).signal)
                        .then(() => props.dispatch({
                            type: 'ABONIEREN_ERFOLGREICH'
                        }))
                        .catch(() => props.dispatch({
                            type: 'ABONIEREN_FEHLGESCHLAGEN'
                        }))
                }}
            >Abonnieren</button>
        </div>
    </div>
};

export default WizardStepSummary;
